import { configureStore } from '@reduxjs/toolkit'
import authReducer from '../features/auth/authSlice'
import carneReducer from '../features/carne/carneSlice'

export default configureStore({
  reducer: {
    auth: authReducer,
    carne: carneReducer
  }
})